var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#111111"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2884 16.1073H14.4688V26.381H11.2884V16.1073ZM12.8791 11.0003C13.896 11.0003 14.7223 11.8299 14.7223 12.8509C14.7223 13.8729 13.896 14.7027 12.8791 14.7027C12.634 14.7074 12.3905 14.6629 12.1627 14.572C11.9349 14.4811 11.7275 14.3455 11.5526 14.1731C11.3776 14.0007 11.2386 13.7951 11.1437 13.5682C11.0489 13.3413 11 13.0976 11 12.8515C11 12.6054 11.0489 12.3618 11.1437 12.1349C11.2386 11.908 11.3776 11.7023 11.5526 11.53C11.7275 11.3576 11.9349 11.222 12.1627 11.1311C12.3905 11.0401 12.634 10.9957 12.8791 11.0003ZM16.4637 16.107H19.5142V17.5109H19.5565C19.9812 16.7032 21.0186 15.8518 22.5657 15.8518C25.7861 15.8518 26.381 17.9797 26.381 20.7461V26.381H23.2025V21.3848C23.2025 20.1936 23.1807 18.6609 21.5501 18.6609C19.8952 18.6609 19.6411 19.9587 19.6411 21.2989V26.381H16.4634V16.1073L16.4637 16.107Z",
    fill: "#117EB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.77817a5e6ca5b7c1c025aec2f858e56d.svg";
export { ForwardRef as ReactComponent };